module.exports = __webpack_public_path__ + "files/61e637e19d177f1a11a4d0c6081e6c68.png";